import { t } from 'i18next'
import React, { useCallback, useMemo, useState, useEffect } from 'react'
import { Alert } from 'react-bootstrap'
import { ButtonWithLoadingState } from '../../Buttons'
import UniversalTableWrapperTest from '../../Table/UniversalTableWrapperTest'
import BootstrapTable from 'react-bootstrap-table-next'
import { useTableState } from '../../Table/TableProvider'
import { getErrorMessageFromApiResponse } from '../../../utils/api/apiUtils'
import { DeleteIcon } from '../../Icons/DeleteIcon'
import { PenIcon } from '../../Icons/PenIcon'
import { isEmptyGuid } from '../../../utils/emptyGuid'
import cellEditFactory from 'react-bootstrap-table2-editor'
import styled from 'styled-components'
import instMgmtApi from '../../../utils/api/instanceMgmt/instMgmtApi'
import { makeCall } from '../../../utils/api/makeCall'
import DisposalModal from '../DisposalModal'
import JobModal from './JobModal'
import { isEmptyStr } from '../../../utils/objectutils'

export const ResponsiveButton = styled.div`
  width: 100%;
  @media (max-width: 768px) {
    width: 100%;
  }
  button {
    width: auto;
    @media (max-width: 768px) {
      width: 100% !important;
    }
  }
`

const StyledHeaderCell = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
const ControlJobsTable = ({ stationId, disabledDisposal = false }) => {
    const [success, setSuccess] = useState('')
    const [error, setError] = useState('')
    const [isSaving, setIsSaving] = useState(false)
    const { tableRef } = useTableState()
    const [allSelected, setAllSelected] = useState(false)
    const [selectedCheckBoxes, setSelectedCheckBoxes] = useState([])
    const [/*errorStates*/, setErrorStates] = useState({})
    const [loadingStates, setLoadingStates] = useState({})
    const [openJobs, setOpenJobs] = useState([])
    const [rfidDisposal, setRfidDisposal] = useState(null)
    const [rfidJob, setRfidJob] = useState(null)

    const loadOpenJobs = useCallback(async () => {
        makeCall('getWashJobs', async () => {
            let loadjobs = await instMgmtApi.getWashJobs(stationId)
            loadjobs = loadjobs.filter((x) => x.type === 'isControlJob')
            loadjobs = loadjobs.map((item) => ({
                ...item,
                addWashCyclesField: 0,
                allowDisposal: !disabledDisposal,
                checkBox: (
                    <span>
                        <input
                            type='checkbox'
                            id={item.id}
                            name='scales'
                            checked={false}
                            onChange={() => { }}
                        ></input>
                    </span>
                ),
            }))
            setOpenJobs(loadjobs)
        }, setErrorStates, setLoadingStates)

    }, [stationId, disabledDisposal])
    useEffect(() => {
        loadOpenJobs()
    }, [loadOpenJobs])
    useEffect(() => {
        setOpenJobs((prev) =>
            prev.map((item) => ({
                ...item,
                checkBox: (
                    <span>
                        <input
                            type='checkbox'
                            id={item.id}
                            name='scales'
                            checked={selectedCheckBoxes.includes(item.id)}
                            onChange={() => { }}
                        ></input>
                    </span>
                ),
            }))
        )
    }, [selectedCheckBoxes])
    const columns = useMemo(
        () => [
            {
                dataField: 'checkBox',
                text: '',
                headerClasses: 'checkBox-header-cell',
                classes: 'checkBox-cell',
                editable: false,
            },
            {
                dataField: 'rfid',
                text: 'inventory:scanCode',
                sort: true,
                editable: false,
            },
            {
                dataField: 'article.articleNumber',
                text: 'localInventoriesTable:articleNumber',
                sort: true,
                editable: false,
            },
            {
                dataField: 'article.displayName',
                text: 'localInventoriesTable:articleName',
                sort: true,
                editable: false,
            },
            {
                dataField: 'variant.displayName',
                text: 'localInventoriesTable:sizeName',
                sort: true,
                editable: false,
            },
            {
                dataField: 'businesspartner.displayName',
                text: 'washPage:bearer',
                sort: true,
                editable: false,
            },
            {
                dataField: 'comment',
                text: 'comment',
                sort: true,
                editable: false,
            },
            {
                dataField: 'washCounter',
                text: 'inventory:washProcess',
                sort: true,
                editable: false,
            },
            {
                dataField: 'washCycles',
                text: 'inventory:washCycles',
                sort: true,
                editable: false,
                formatter: (cell, row, rowIndex, extraProps) =>
                    <>
                        {!!row.washCycles ? row.washCycles : ''}
                    </>
            },
            {
                dataField: 'addWashCyclesField',
                text: 'washPage:washCountAdd',
                sort: true,
                classes: 'cursor-pointer',
                editable: (cell, row, rowIndex, colIndex) => {
                    return !!row.washCycles
                },
                formatter: (cell, row, rowIndex, extraProps) =>
                    <>
                        {!!row.washCycles ? row.addWashCyclesField : ''}
                    </>
            },
            {
                isDummyField: true,
                dataField: 'isDummyField',
                text: '',
                sort: false,
                headerClasses: 'checkBox-header-cell',
                classes: 'checkBox-cell',
                editable: (cell, row, rowIndex, colIndex) => {
                    return false
                },
                formatter: (cell, row, rowIndex, extraProps) =>
                    <span>
                        <span
                            role='button'
                            onClick={(e) => {
                                extraProps.handleEditRow(e)(row, cell)
                            }}
                        >
                            <PenIcon title={t('edit')} />
                        </span>
                        {row.allowDisposal && <span
                            role='button'
                            onClick={(e) => {
                                extraProps.handleRemoveRow(e)(row, cell)
                            }}
                        >
                            <DeleteIcon title={t('washPage:discardArticle')} />
                        </span>}
                    </span>
            },
        ],
        []
    )
    const onRowClick = (cell, row) => {
        const { cursor } = getComputedStyle(cell.target)
        if (cursor === 'pointer' && !!row.washCycles) {
            return false
        }
        if (allSelected) {
            setAllSelected(false)
        }
        if (selectedCheckBoxes.includes(row.id)) {
            var index = selectedCheckBoxes.indexOf(row.id)
            var newValues = [...selectedCheckBoxes]
            newValues.splice(index, 1)
            setSelectedCheckBoxes(newValues)
        } else {
            setSelectedCheckBoxes((prev) => [...prev, row.id])
        }
    }
    const selectAll = useCallback(() => {
        if (allSelected || openJobs.length < 1) {
            setAllSelected(false)
            setSelectedCheckBoxes([])
        } else {
            const arrayOfAllIds = openJobs.map((obj) => obj.id)
            setSelectedCheckBoxes(arrayOfAllIds)
            setAllSelected(true)
        }
    }, [openJobs, allSelected])
    const handleRemoveRow = useCallback((e) => (row, cell) => {
        setRfidDisposal(row)
    }, [])
    const handleEditRow = useCallback((e) => (row, cell) => {
        setRfidJob(row)
    }, [])

    const handleAfterSaveCell = (oldValue, newValue, row, column) => {
        var jobs = [...openJobs]
        let value = (isEmptyStr(newValue) || parseInt(newValue) === 0) ? 0 : (parseInt(newValue) || oldValue)
        let foundIndex = jobs.findIndex((item) => item.id === row.id)
        if (foundIndex >= 0) {
            jobs[foundIndex].addWashCyclesField = value
            setOpenJobs(openJobs)
        }
    }
    const preparedColumns = useMemo(() => {
        const tmpColumns = [...columns]
        tmpColumns.forEach((tmpColumn) => {
            tmpColumn.headerFormatter = (column, colIndex, components) => {
                switch (tmpColumn.dataField) {
                    case 'checkBox':
                        return (
                            <span>
                                <input
                                    type='checkbox'
                                    id='checkbox_header'
                                    name='scales'
                                    checked={allSelected}
                                    onChange={selectAll}
                                ></input>
                            </span>
                        )
                    default:
                        return (
                            <>
                                <StyledHeaderCell>
                                    {column.text}
                                    {components.sortElement}
                                </StyledHeaderCell>
                            </>
                        )
                }
            }
        })
        tmpColumns.forEach((tmpColumn) => {
            tmpColumn.text = t(tmpColumn.text)
        })
        tmpColumns.find((col) => col.dataField === 'isDummyField').formatExtraData =
        {
            handleRemoveRow,
            handleEditRow,
        }
        const ignoreColumns = () => {
            var result = []
            if (!openJobs.find((x) => !isEmptyGuid(x.variant?.id))) {
                result.push('variant.displayName')
            }
            if (!openJobs.some((x) => !!x.washCycles)) {
                result.push('washCycles')
                result.push('addWashCyclesField')
            }
            if (!openJobs.some((x) => !!x.comment)) {
                result.push('comment')
            }
            return result
        }

        return tmpColumns.filter(
            (item) => !ignoreColumns().includes(item.dataField)
        )
    }, [allSelected, selectAll, handleRemoveRow, handleEditRow, columns, openJobs])
    const handleSave = async () => {
        setIsSaving(true)
        setError('')
        try {
            let updateJobs = openJobs.filter((x) => selectedCheckBoxes.includes(x.id)).map((e) => {
                return {
                    additionalWashCycles: e.addWashCyclesField,
                    rfid: e.rfid,
                    id: e.id,
                }
            })
            let params = {
                jobs: updateJobs,
                action: 'closeControlJob',
                stationId: stationId
            }
            await instMgmtApi.updateWashJobs(params)
            await loadOpenJobs()
            setSuccess(t('EmployeeFormSidebar:dataSaved'))
        } catch (e) {
            setError(getErrorMessageFromApiResponse(e))
        }
        setIsSaving(false)
    }

    const handleCloseJobModal = async (closed) => {
        if (closed) {
            var jobs = [...openJobs]
            let foundIndex = jobs.findIndex((item) => item.rfid === rfidJob.rfid)
            if (foundIndex >= 0) {
                jobs.splice(foundIndex, 1)
                setOpenJobs(jobs)
            }
        }
        setRfidJob(null)
    }
    const handleCloseDisposalModal = async (disposed) => {
        if (disposed) {
            var jobs = [...openJobs]
            let foundIndex = jobs.findIndex((item) => item.rfid === rfidDisposal.rfid)
            if (foundIndex >= 0) {
                jobs.splice(foundIndex, 1)
                setOpenJobs(jobs)
            }
        }
        setRfidDisposal(null)
    }
    return (
        <>
            <UniversalTableWrapperTest>
                <BootstrapTable
                    ref={tableRef}
                    loading={loadingStates.getWashJobs}
                    noDataIndication={() => (
                        <div className='no-data-placeholder'>{t('inventory:noData')}</div>
                    )}
                    bootstrap4
                    keyField='id'
                    hover
                    data={openJobs}
                    columns={preparedColumns}
                    bordered={false}
                    rowEvents={{ onClick: onRowClick }}
                    cellEdit={cellEditFactory({
                        mode: 'click',
                        blurToSave: true,
                        afterSaveCell: handleAfterSaveCell,
                        autoSelectText: true,
                    })}
                />
            </UniversalTableWrapperTest>
            {error ? <Alert variant='danger'>{error}</Alert> : null}
            {success ? <Alert variant='success'>{success}</Alert> : null}
            <ButtonWithLoadingState
                variant='primary'
                buttonText={t('washPage:closeJobs')}
                isLoading={isSaving}
                disabled={!selectedCheckBoxes?.length}
                onClick={(e) => handleSave()}
            />
            {rfidDisposal ? (
                <DisposalModal
                    scanCodeObj={rfidDisposal}
                    handleClose={handleCloseDisposalModal}
                />
            ) : null}
            {rfidJob ? (
                <JobModal
                    scanCode={rfidJob.rfid}
                    handleClose={handleCloseJobModal}
                    isFirstScan={!rfidJob.wasAlreadyScaned}
                />
            ) : null}
        </>
    )
}

export default ControlJobsTable
